export default __webpack_public_path__ + "static/media/back.14170e90.svg";